/* import __COLOCATED_TEMPLATE__ from './sentiment-neutral.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {number} */
  width: 24,

  /** @type {number} */
  height: 24,
});
